import { buildAdminNavIcons } from '../../../icons/AdminNavIcons';
import { buildArtifactIcons } from '../../../icons/ArtifactIcons';
import { buildCameraIcons } from '../../../icons/CameraIcons';
import { buildCheckboxIcons } from '../../../icons/CheckboxIcons';
import { buildExtraNeedsIcons } from '../../../icons/ExtraNeedsIcons';
import { buildFieldAppIcons } from '../../../icons/FieldAppIcons';
import { buildGeneralIcons } from '../../../icons/GeneralIcons';
import { buildHexagonIcons } from '../../../icons/HexagonIcons';
import { buildKaiIcon } from '../../../icons/KaiIcon';
import { buildProgressIcons } from '../../../icons/ProgressIcons';
import { buildStatusIcons } from '../../../icons/StatusIcons';
import { buildSupportIcon } from '../../../icons/SupportIcon';
import { buildUtilityIcons } from '../../../icons/UtilityIcons';
import { webPrimitives } from './primitives';

export type { IconProps } from '../../../icons/types';

export const {
  DashboardIcon,
  HomesIcon,
  PropertiesIcon,
  MarketsIcon,
  ContractorsIcon,
  ProductsIcon,
  TemplatesIcon,
  UsersIcon,
  OrgSettingsIcon,
} = buildAdminNavIcons(webPrimitives);

export const {
  ScopeIcon,
  ChangeOrderIcon,
  CloseOutIcon,
  ScopeAddendumIcon,
} = buildArtifactIcons(webPrimitives);

export const {
  CameraCloseIcon,
  FlipCameraIcon,
  UploadFromDeviceIcon,
  DeletePhotoIcon,
} = buildCameraIcons(webPrimitives);

export const {
  DefaultCheckboxIcon,
  SelectedCheckboxIcon,
} = buildCheckboxIcons(webPrimitives);

export const {
  PauseIcon,
  StopIcon,
  PhotoIcon,
  MissingPhotoIcon,
  InsightTipIcon,
  ImageUnavailableIcon,
  OutOfStockItemIcon,
  UnassignedContractorIcon,
  BatterySaveModeIcon,
  GroupIcon,
  TradesIcon,
  ProjectsIcon,
  ArchiveIcon,
  StorageIcon,
  // Streamline-Cyber (2026 Kai Styleguide)
  VideoIcon,
  DuplicateIcon,
  TenantResponsibleIcon,
  DeferredIcon,
} = buildExtraNeedsIcons(webPrimitives);

export const {
  CameraIcon,
  TasksIcon,
  NotesIcon,
  SettingsIcon,
  FieldEditIcon,
  ChangeIcon,
  RemoveIcon,
} = buildFieldAppIcons(webPrimitives);

export const {
  DirectionsIcon,
  CheckIcon,
  LockIcon,
  LeftIcon,
  RightIcon,
  EditIcon,
  LiveIcon,
  WalkIcon,
  DetailsIcon,
  CalendarIcon,
} = buildGeneralIcons(webPrimitives);

export const {
  NotStartedIcon,
  InProgressIcon,
  ProgressIcon,
  ReworkIcon,
  PunchListIcon,
  CompleteIcon,
} = buildProgressIcons(webPrimitives);

export const {
  KaiIcon,
} = buildKaiIcon(webPrimitives);

export const {
  HexagonOutlineIcon,
  HexagonFilledIcon,
} = buildHexagonIcons(webPrimitives);

export const {
  OnlineIcon,
  OfflineIcon,
  UpdatingIcon,
} = buildStatusIcons(webPrimitives);

export const {
  SupportIcon,
} = buildSupportIcon(webPrimitives);

export const {
  SearchIcon,
  FilterIcon,
  ListIcon,
  AddIcon,
  PlusIcon,
  MinusIcon,
  CloseIcon,
  BackIcon,
  BackArrowIcon,
  BackToTopIcon,
  UpArrowIcon,
  DownArrowIcon,
  LeftArrowIcon,
  RightArrowIcon,
  NotificationIcon,
  DownloadIcon,
  UploadIcon,
  UploadFromComputerIcon,
  TrashIcon,
  CollapseCaretIcon,
  UndoIcon,
  MoreMenuIcon,
  MoreVerticalIcon,
  DropdownIcon,
  DropdownArrowIcon,
  NoteIcon,
  InfoCircleIcon,
  ErrorIcon,
  AlertIcon,
  FlagIcon,
  SortIcon,
  CloudSyncIcon,
  UserProfileIcon,
  LogoutIcon,
} = buildUtilityIcons(webPrimitives);
